export default "__VITE_ASSET__CS9VF$Kn__"